<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue'
import { $bus } from '@/common/events'
import { $router } from '@/router'
import { useCabinetAlarm } from '@/composables/alarm'
import { ConfigService } from '@/services/ConfigService.js'
import ServiceNotice from '@/components/Maintenance/ServiceNotice.vue'
import DebugFooter from '@/components/Maintenance/DebugFooter.vue'
import Button from '@/components/Button.vue'

const { mode, message, alarmBus } = useCabinetAlarm();

const emit = defineEmits(["change"]);

const configService = new ConfigService();

onMounted(() => {
});

onUnmounted(() => {
});

function addBodyClass() {
  if (document.body) {
    document.body.classList.add("alarm");
  }
}

function removeBodyClass() {
  if (document.body) {
    document.body.classList.remove("alarm");
  }
}

watch(mode, (value) => {
  emit("change", { mode: value });
  if (value && typeof value == "string" && value.trim().length) {
    addBodyClass();
  }
  else {
    removeBodyClass();
  }
});

function continueRequest() {
  if (mode.value == "disrupt") {
    setTimeout(() => useCabinetAlarm(false), 500);
    $router.push({ name: "Index" });
  }
  else {
    useCabinetAlarm(false);
  }
  alarmBus.emit("continue");
}
</script>

<template>
  <Teleport to="body" v-if="mode">
    <div class="fullscreen bg-white">

      <!-- Service mode notice -->
      <ServiceNotice />

      <!-- Alarm raised -->
      <div class="always-on-top" v-if="mode">
        <div class="grid h-screen place-items-center">
          <div class="text-center">
            <i class="fa fa-circle-exclamation text-red-600" style="font-size: 210px;"></i>

            <!-- Title -->
            <div class="mt-5 text-lg font-bold" v-if="mode == 'halt'">Ročna zaustavitev</div>
            <div class="mt-5 text-lg font-bold" v-else-if="mode == 'curtain'">Prekinjena zavesa</div>
            <div class="mt-5 text-lg font-bold" v-else-if="mode == 'disrupt'">Prekinitev napajanja na krmilniku</div>
            <div class="mt-5 text-lg font-bold" v-else>Prekinitev</div>

            <!-- Message: instructions for the user -->
            <div class="mt-5" v-if="mode == 'halt'">Vklopljena je tipka za izklop v sili.<br />Za nadaljevanje izvlecite tipko za izklop v sili<br />in pritisnite nadaljuj.</div>
            <div class="mt-5" v-else>Zaznana je bila prekinitev.</div>

            <!-- Button to continue -->
            <div class="mt-5" v-if="mode == 'halt' || mode == 'disrupt'">
              <Button type="primary" :enabled="true" @click="continueRequest()">Nadaljuj</Button>
              <!-- <Spinner size="10" style="margin: 0 auto;" v-if="!moving" /> -->
            </div>

          </div>
        </div>
      </div>

      <DebugFooter></DebugFooter>

    </div>
  </Teleport>
</template>

<style scoped>
.fullscreen {
  display: block;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 890;
  overflow: hidden;
  @apply w-full h-screen;
}

body.maintenance {
  overflow: hidden;
  background: white;
  padding: 0px;
  margin: 0px;
  width: 100%;
  height: 100% !important;
  max-height: 100% !important;
}
</style>
